import React from 'react';
import { FiUpload } from 'react-icons/fi';

const LoadConfirmDialog = ({
  show,
  loadMode,
  setLoadMode,
  onConfirm,
  onCancel
}) => {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        minWidth: '480px',
        maxWidth: '90vw'
      }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '8px', color: '#f57c00' }}>
          <FiUpload />
          Struktur laden - Modus wählen
        </h3>
        <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#333', lineHeight: '1.5' }}>
          Wie sollen die geladenen Daten behandelt werden?
        </p>
        
        {/* Modus-Auswahl */}
        <div style={{ margin: '0 0 24px 0' }}>
          <div style={{ 
            marginBottom: '12px',
            padding: '12px',
            border: loadMode === 'replace' ? '2px solid #f57c00' : '2px solid #e0e0e0',
            borderRadius: '8px',
            cursor: 'pointer',
            backgroundColor: loadMode === 'replace' ? '#fff3e0' : 'white'
          }} onClick={() => setLoadMode('replace')}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="loadMode"
                value="replace"
                checked={loadMode === 'replace'}
                onChange={() => setLoadMode('replace')}
                style={{ marginRight: '10px' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>
                  🔄 Überschreiben (Ersetzen)
                </div>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                  Alle aktuellen Panel-Gruppen und das Startdatum werden durch die geladenen Daten ersetzt
                </div>
              </div>
            </label>
          </div>
          
          <div style={{ 
            padding: '12px',
            border: loadMode === 'append' ? '2px solid #4caf50' : '2px solid #e0e0e0',
            borderRadius: '8px',
            cursor: 'pointer',
            backgroundColor: loadMode === 'append' ? '#e8f5e8' : 'white'
          }} onClick={() => setLoadMode('append')}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="loadMode"
                value="append"
                checked={loadMode === 'append'}
                onChange={() => setLoadMode('append')}
                style={{ marginRight: '10px' }}
              />
              <div>
                <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>
                  ➕ Anhängen (Hinzufügen)
                </div>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                  Die geladenen Panel-Gruppen werden zu den bestehenden hinzugefügt (Startdatum bleibt unverändert)
                </div>
              </div>
            </label>
          </div>
        </div>

        {loadMode === 'replace' && (
          <div style={{ 
            padding: '12px', 
            backgroundColor: '#fff3e0', 
            border: '1px solid #ffb74d', 
            borderRadius: '6px', 
            marginBottom: '20px' 
          }}>
            <div style={{ fontSize: '12px', color: '#e65100', fontWeight: '500' }}>
              ⚠️ Warnung: Alle nicht gespeicherten Änderungen gehen verloren!
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            style={{
              padding: '10px 20px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              backgroundColor: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onClick={onCancel}
          >
            Abbrechen
          </button>
          <button
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '6px',
              backgroundColor: loadMode === 'replace' ? '#f57c00' : '#4caf50',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onClick={onConfirm}
          >
            <FiUpload style={{ marginRight: '6px' }} />
            {loadMode === 'replace' ? 'Überschreiben' : 'Anhängen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoadConfirmDialog;
